/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import * as _ from 'lodash';

import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';

import { AppUtilityService } from '../../../core/services/app-utility.service';
import { ConfigService } from '../../../core/services/config.service';
import { LocoDetail } from '../../../core/model/loco-detail.model';
import { NotesDetails } from './../../model/notes-details.model';
import { PopupService } from '../../../core/services/popup.service';
import { StaticDataStoreService } from '../../../core/services/static-datastore.service';
import { Tab } from './../../../core/model/tab.model';
import { TerminalCommonInfo } from '../../../core/model/terminal-common-info.model';
import { UserService } from '../../../core/services/user.service';

/**
 * @export
 * @class LmsNotesHeaderComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'lms-notes-header',
  templateUrl: './lms-notes-header.component.html',
  styleUrls: ['./lms-notes-header.component.scss']
})
export class LmsNotesHeaderComponent implements OnInit, OnChanges, OnDestroy {

  @Input() subTypes: Array<string>;
  @Output() updateNotesList: EventEmitter<string> = new EventEmitter<string>();
  @Output() cancelEditNotes: EventEmitter<string> = new EventEmitter<string>();
  @Input() tab: Tab;
  @Output() deleteAllNote: EventEmitter<string> = new EventEmitter<string>();
  @Input() enableDeleteAll: boolean;
  @Input() notesList: NotesDetails;
  @Input() addNoteText: string;
  summary: TerminalCommonInfo;
  tabLevel: number;
  locoSVG: LocoDetail;
  iconSubscription: any;
  lastRequestTime: number;
  iconIdentified: boolean;
  breakCall = false;

  constructor(private staticDataStoreService: StaticDataStoreService, private configService: ConfigService,
    private popupService: PopupService, private appUtilityService: AppUtilityService, public user: UserService) {
    this.tabLevel = this.configService.getConfigData().tabIndex.subTabs;
  }

  ngOnInit() {
  }

  /**
   * @memberOf LmsNotesHeaderComponent
   */
  public updateNotes() {
    this.updateNotesList.emit('');
  }

  /**
   * @memberOf LmsNotesHeaderComponent
   */
  public cancelNoteSave() {
    this.cancelEditNotes.emit('');
  }

  /**
   * @memberOf LmsNotesHeaderComponent
   */
  public deleteAllNotes() {
    this.deleteAllNote.emit('deleteAll');
  }

  /**
   * This method determines whether to enable or disable the save button on header
   * @returns
   * @memberOf LmsNotesHeaderComponent
   */
  checkEmptyEditedNote() {
    for (const note of this.notesList.listOfNotes) {
      if (note.editMode && note.editMode === 'Y') {
        if (note.editedNoteText.trim().length === 0) {
          return true;
        } else {
          return false;
        }
      }
    }
    if (this.addNoteText && this.addNoteText.trim().length !== 0) {
      return true;
    } else {
      return false;
    }
  }

  ngOnChanges() {
    const commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');
    if (commonopsPicklist && commonopsPicklist.setOfTerminals) {
      const terminalCommonInfoArr = commonopsPicklist.setOfTerminals;
      if (terminalCommonInfoArr && this.tab.tabSearchParameter && this.tab.tabSearchParameter.searchText) {
        this.summary = _.find(terminalCommonInfoArr,
          { 'terminalMnemonic': this.tab.tabSearchParameter.searchText.trim().toUpperCase() });
        if (this.summary) {
          if (this.summary.city) {
            this.summary.city = this.summary.city.trim();
          }
          if (commonopsPicklist.masterData && commonopsPicklist.masterData.divisonList) {
            const divisionArr = commonopsPicklist.masterData.divisonList;
            if (divisionArr && this.summary) {
              const divisionObj: TerminalCommonInfo = _.find(divisionArr, { 'divisionCode': this.summary.divisionCode });
              if (divisionObj) {
                this.summary.divisionName = divisionObj.divisionName;
              }
            }
          }
        }
      }
    }
    if (this.tab.tabSearchParameter && this.tab.tabSearchParameter.icon && this.tab.subTypeDetail && this.tab.subTypeDetail.notes && this.tab.type === 'Locomotive') {
      if (this.tab.subTypeDetail.notes.status === 'loaded') {
        this.locoSVG = this.tab.tabSearchParameter.icon;
        this.crossCheckLocoIcon();
      } else if (this.tab.subTypeDetail.notes.status === 'refresh') {
        this.refreshLocomotiveIconInformation();
      }
    } else if (this.tab && this.tab.tabSearchParameter && this.tab.tabSearchParameter.searchText && this.tab.type === 'Locomotive') {
      this.refreshLocomotiveIconInformation();
    }
  }

  private refreshLocomotiveIconInformation() {
    const currentTime = (new Date()).getTime();
    if (!this.lastRequestTime || (currentTime - this.lastRequestTime) > 600) {
      this.popupService.getLocomotiveIconInformation(this.tab, this.tab.tabSearchParameter.searchText);
      this.iconSubscription = this.popupService.locoIconObservable.subscribe((data) => {
        if (data.data) {
          this.locoSVG = data.data;
          this.iconIdentified = data && data.opr && data.opr === 'success' ? true : false;
        }
        this.crossCheckLocoIcon();
      });
      this.lastRequestTime = currentTime;
    }
  }

  private crossCheckLocoIcon() {
    if (!this.locoSVG || !this.locoSVG.locomotiveIdentifier) {
      this.locoSVG = <LocoDetail>{};
      if (!this.locoSVG.locomotiveIdentifier) {
        this.locoSVG.locomotiveIdentifier = this.tab.tabSearchParameter.searchText;
      }
    } else {
      this.iconIdentified = true;
    }
  }

  ngOnDestroy() {
    if (this.iconSubscription) {
      this.iconSubscription.unsubscribe();
    }
  }
}
